"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddedItemWrapper = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderBottom: `2px solid ${theme.palette.grey[100]}`,
  boxShadow: `0 3px 8px 0 ${(0, _mui.alpha)(theme.palette.grey[900], 0.05)}`,
  boxSizing: 'border-box',
  cursor: 'pointer',
  padding: theme.spacing(0, 3, 0),
  [theme.breakpoints.down(_constants.XXS)]: {
    padding: theme.spacing(0, 2, 0)
  }
}));
const Header = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  minHeight: 40,
  paddingRight: theme.spacing(6),
  postition: 'relative',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down(_constants.XXS)]: {
    fontSize: theme.typography.caption.fontSize
  }
}));
const ProductInfo = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.disabled,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));
const ExpandIcon = (0, _mui.styled)(_components.IconButton)(({
  ownerState: {
    isExpanded
  },
  theme
}) => ({
  fontSize: '3.6rem',
  height: 30,
  marginLeft: 'auto',
  position: 'absolute',
  right: theme.spacing(2),
  transform: `rotate(${isExpanded ? 180 : 0}deg)`,
  transition: 'transform 0.2s ease-in-out',
  width: 30
}));
const AddedItemWrapper = ({
  title,
  children
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const togglePurchasedItems = (0, _react.useCallback)(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId('purchased-items-toggle'),
    onClick: togglePurchasedItems,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Header, {
      "data-testid": getTestId('purchased-items-header'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        fontSize: "inherit",
        marginRight: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "youAdded"
        })
      }), !isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductInfo, {
        fontSize: "inherit",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ExpandIcon, {
        variant: "text",
        color: "default",
        ownerState: {
          isExpanded
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
          fontSize: "inherit"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Collapse, {
      "data-testid": getTestId('purchased-items-content'),
      in: isExpanded,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "caption",
        component: "p",
        marginBottom: 1,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "productsThatMadeYouEligibleForThisOffer"
        })
      }), children]
    })]
  });
};
exports.AddedItemWrapper = AddedItemWrapper;